export const searchElements = {
  'No Lunch Shifts': 'isNoLunchShifts',
  'HOO Changed': 'isHOOChanged',
  'New Hires': 'isNewHires',
  'Integrations': 'isIntegrations',
  'Practitioner Days': 'isPractitionerDays',
  'Outside of HOO': 'isOutsideOfHOO',
  'Other Reasons': 'isOtherReasons',
};
